import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { PreUniversityService } from './previous.university.service';
import { UtilService } from '../common/util.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { PreviousEnrollment } from './previousEnrollment';

@Component({
  selector: 'app-previous-university',
  templateUrl: './previous-university.component.html',
  styleUrls: ['./previous-university.component.scss'],
})
export class PreviousUniversityComponent implements OnInit, OnDestroy {
  @ViewChild('university', { static: false }) university!: ElementRef;
  @ViewChild('fullName', { static: false }) fullName!: ElementRef;
  @ViewChild('hostelName', { static: false }) hostelName!: ElementRef;
  @ViewChild('programme', { static: false }) programme!: ElementRef;
  @ViewChild('reason', { static: false }) reason!: ElementRef;

  model: any;
  personId: string = '';
  reasonsForLeaving: string = '';
  lastYearOfStudy: string = '';
  programmeOfStudy: string = '';
  residencyName: string = '';
  admissionYear: string = '';
  namesUsed: string = '';
  universityName: string = '';
  previousEnrollment: string = '';
  admissionYearModel!: NgbDateStruct;
  lastYearOfStudyModel!: NgbDateStruct;
  previousEnrollmentId: string = '';
  ERROR_INITIAL_MESSAGE = 'ERROR: Please fill in the required field(s): ';

  characterOnlyErrorForUniversityName = '';
  characterOnlyErrorForProgramme = '';
  characterOnlyErrorForHostel = '';
  characterOnlyErrorForReason = '';
  characterOnlyErrorForName = '';

  constructor(
    private router: Router,
    private preUniversityService: PreUniversityService,
    private utilService: UtilService
  ) {
    this.personId = localStorage.getItem('personId') || '';
  }

  ngOnInit() {
    this.preUniversityService.getPreviousEnrolment(this.personId).subscribe((previousEnrollment) => {
      this.previousEnrollmentId = previousEnrollment.previousEnrollmentId;
      this.previousEnrollment = previousEnrollment.previousEnrollment;
      this.universityName = previousEnrollment.universityName;
      this.namesUsed = previousEnrollment.namesUsed;
      this.admissionYear = previousEnrollment.admissionYear;
      if (this.admissionYear !== null) {
        let admissionYearArray = this.admissionYear.split('-');
        this.admissionYearModel = {
          year: parseInt(admissionYearArray[0]),
          month: parseInt(admissionYearArray[1]),
          day: parseInt(admissionYearArray[2]),
        };
      }

      this.residencyName = previousEnrollment.residencyName;
      this.programmeOfStudy = previousEnrollment.programmeOfStudy;
      this.lastYearOfStudy = previousEnrollment.lastYearOfStudy;
      if (this.lastYearOfStudy !== null) {
        let lastYearOfStudyArray = this.lastYearOfStudy.split('-');
        this.lastYearOfStudyModel = {
          year: parseInt(lastYearOfStudyArray[0]),
          month: parseInt(lastYearOfStudyArray[1]),
          day: parseInt(lastYearOfStudyArray[2]),
        };
      }

      this.reasonsForLeaving = previousEnrollment.reasonsForLeaving;
    });
    var body = document.getElementsByTagName('body')[0];
    body.classList.add('full-screen');
    body.classList.add('previous-university');
    var navbar = document.getElementsByTagName('nav')[0];
    navbar.classList.add('navbar-transparent');
  }
  ngOnDestroy() {
    var body = document.getElementsByTagName('body')[0];
    body.classList.remove('full-screen');
    body.classList.remove('previous-university');
    var navbar = document.getElementsByTagName('nav')[0];
    navbar.classList.remove('navbar-transparent');
  }

  updatePreUniversityDetails(pageName: string) {
    if (this.previousEnrollment == '1') {
      let previousEnrollment = new PreviousEnrollment();
      previousEnrollment.admissionYear = this.utilService.getDBFormattedDate(this.admissionYearModel);
      previousEnrollment.lastYearOfStudy = this.utilService.getDBFormattedDate(this.lastYearOfStudyModel);
      previousEnrollment.namesUsed = this.namesUsed;
      previousEnrollment.personId = this.personId;
      previousEnrollment.previousEnrollment = this.previousEnrollment;
      previousEnrollment.previousEnrollmentId = this.previousEnrollmentId;
      previousEnrollment.programmeOfStudy = this.programmeOfStudy;
      previousEnrollment.reasonsForLeaving = this.reasonsForLeaving;
      previousEnrollment.residencyName = this.residencyName;
      previousEnrollment.universityName = this.universityName;
      var errorMessage = this.validateFields();
      if (
        errorMessage === this.ERROR_INITIAL_MESSAGE &&
        this.characterOnlyErrorForHostel.length === 0 &&
        this.characterOnlyErrorForName.length === 0 &&
        this.characterOnlyErrorForProgramme.length === 0 &&
        this.characterOnlyErrorForReason.length === 0 &&
        this.characterOnlyErrorForUniversityName.length === 0
      ) {
        this.preUniversityService.savePreuniversityDetails(previousEnrollment).subscribe((response) => {
          if (response !== undefined) {
            this.router.navigateByUrl('/' + pageName);
          }
        });
      } else {
        if (this.characterOnlyErrorForUniversityName.length > 0) {
          this.university.nativeElement.focus();
        } else if (this.characterOnlyErrorForName.length > 0) {
          this.fullName.nativeElement.focus();
        } else if (this.characterOnlyErrorForHostel.length > 0) {
          this.hostelName.nativeElement.focus();
        } else if (this.characterOnlyErrorForProgramme.length > 0) {
          this.programme.nativeElement.focus();
        } else if (this.characterOnlyErrorForReason.length > 0) {
          this.reason.nativeElement.focus();
        }
      }
    } else {
      this.router.navigateByUrl('/' + pageName);
    }
  }

  validateFields() {
    var errorMessage = this.ERROR_INITIAL_MESSAGE;

    if (this.universityName === undefined || this.universityName.trim() === '') {
      errorMessage = errorMessage + 'University name,';
    }

    if (this.namesUsed === undefined || this.namesUsed.trim() === '') {
      errorMessage = errorMessage + 'Name used in university, ';
    }
    var admissionYearTextBox = document.getElementById('date1');
    if (this.admissionYearModel === undefined) {
      errorMessage = errorMessage + 'Admission date, ';
    }
    if (this.programmeOfStudy === undefined || this.programmeOfStudy.trim() === '') {
      errorMessage = errorMessage + 'Programme of study, ';
    }

    if (this.lastYearOfStudyModel === undefined) {
      errorMessage = errorMessage + 'Date of study, ';
    }

    if (this.reasonsForLeaving === undefined || this.reasonsForLeaving.trim() === '') {
      errorMessage = errorMessage + 'Reason(s) of leaving, ';
    }
    var lastChar = errorMessage.trim().substring(errorMessage.length - 2);
    if (lastChar === ',') {
      errorMessage = errorMessage.trim().substring(0, errorMessage.length - 2);
    }

    return errorMessage;
  }

  characterOnly(event: any, elementName: string) {
    let characterOnlyError = '';
    if (!this.utilService.validateSubject(event.target.value)) {
      characterOnlyError = 'No special characters allowed only a-zA-Z';
    }

    if (elementName === 'university') {
      this.characterOnlyErrorForUniversityName = characterOnlyError;
    }
    if (elementName === 'programme') {
      this.characterOnlyErrorForProgramme = characterOnlyError;
    }
    if (elementName === 'hostel') {
      this.characterOnlyErrorForHostel = characterOnlyError;
    }
    if (elementName === 'reason') {
      this.characterOnlyErrorForReason = characterOnlyError;
    }

    this.autoSave();
  }

  validateName(event: any, elementName: string) {
    let characterOnlyError = '';

    if (!this.utilService.validateName(event.target.value)) {
      characterOnlyError = 'No special characters allowed only a-zA-Z -';
    }

    if (elementName === 'name') {
      this.characterOnlyErrorForName = characterOnlyError;
    }

    this.autoSave();
  }

  clearErrorMessage(event: any) {}

  public autoSave() {
    this.updatePreUniversityDetails('previous-university');
  }
}